/*
 * pg-kup-teraz.js. Przycisk „Kup teraz” obok „Dodaj do koszyka” (snippets/product-form.liquid).
 * „Dodaj do koszyka” zostaje bez zmian (szuflada z akcesoriami i paskiem darmowej dostawy). „Kup teraz”:
 *   1. dodaje ten produkt (wariant, ilość, ukryte właściwości pozycji, np. _Termin realizacji) i zaznaczone na karcie akcesoria
 *      jednym żądaniem /cart/add.js (ta sama droga co „Dodaj do koszyka” z akcesoriami w pg-product.js),
 *   2. gdy klient dał zgodę na analitykę albo marketing, czeka najwyżej 2 s, aż ProfitMetrics zapisze dane wizyty przy koszyku
 *      (PM 144: metapole koszyka profitmetrics.tracking, znacznik localStorage _pmct = set|<skrót>:<koszyk>); bez zgody PM nic nie pisze,
 *      więc przejście jest od razu,
 *   3. przechodzi do kasy zwykłym formularzem koszyka (POST /cart z przyciskiem name=checkout), tak jak „Przejdź do kasy” w szufladzie.
 * Między 1 a 2 termin pozycji dla ilości większej niż stan poprawia window.__pgCartLeadSprawdz (assets/pg-global.js,
 * część „cart-lead”), bo stanu nie ma w stronie; bez tej funkcji przejście jak dotąd.
 * Kodów reklam i ProfitMetrics nie zmienia tylko czeka na ich zapis. Błąd dodania: komunikat pod przyciskiem, bez przejścia.
 */
(function () {
  'use strict';
  if (window.__pgKupTeraz) return;
  window.__pgKupTeraz = 'j0283-0334';

  var CZEKAJ_PM_MS = 2000;

  function ciastko(n) {
    var m = document.cookie.match(new RegExp('(^|;\\s*)' + n + '=([^;]*)'));
    if (!m) return null;
    try { return decodeURIComponent(m[2]); } catch (e) { return null; }
  }

  /* Zgoda jak w kodzie PM (et): API prywatności Shopify (analityka albo marketing), a bez niego dane wizyty PM z flagą zgody. */
  function zgodaPM() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      if (p && typeof p.analyticsProcessingAllowed === 'function') return !!(p.analyticsProcessingAllowed() || p.marketingAllowed());
    } catch (e) { /* bez API */ }
    var d = ciastko('_pma');
    if (!d) { try { d = window.localStorage.getItem('_pma'); } catch (e) { d = null; } }
    if (!d) return false;
    try { var j = JSON.parse(d); return !!(j && (j.cc_statistics || j.cc_marketing)); } catch (e) { return false; }
  }

  function zapisPMGotowy() {
    var koszyk = ciastko('cart');
    var s = null;
    try { s = window.localStorage.getItem('_pmct'); } catch (e) { s = null; }
    return !!(koszyk && s && s.indexOf('set|') === 0 && s.slice(-(koszyk.length + 1)) === ':' + koszyk);
  }

  function czekajNaPM() {
    return new Promise(function (gotowe) {
      if (!zgodaPM()) { gotowe('bez-zgody'); return; }
      var start = Date.now();
      (function krok() {
        if (zapisPMGotowy()) { gotowe('zapisane'); return; }
        if (Date.now() - start > CZEKAJ_PM_MS) { gotowe('limit'); return; }
        setTimeout(krok, 100);
      })();
    });
  }

  function pozycje(form) {
    var fd = new FormData(form);
    /* id wariantu: pole name=id formularza motywu jest wyłączone (disabled), więc FormData go pomija; wartość czytamy wprost z pola,
       a gdy go brak: z adresu (?variant=) albo z ShopifyAnalytics (próba 25.10, j0283-0329: komunikat błędu zamiast dodania) */
    var poleId = form.querySelector('[name="id"]');
    var vid = (poleId && poleId.value) || new URLSearchParams(location.search).get('variant') || (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId) || '';
    var glowna = { id: parseInt(vid, 10), quantity: Math.max(1, parseInt(fd.get('quantity') || '1', 10) || 1) };
    var wl = {};
    fd.forEach(function (v, k) {
      var m = /^properties\[(.+)\]$/.exec(k);
      if (m && typeof v === 'string' && v !== '') wl[m[1]] = v;
    });
    if (Object.keys(wl).length) glowna.properties = wl;
    var plan = fd.get('selling_plan');
    if (plan) glowna.selling_plan = parseInt(plan, 10);
    var lista = [];
    /* akcesoria zaznaczone na karcie (pdp-direct-accessories), jak przy „Dodaj do koszyka”. 27.10.2026 
       z ich ilościami i terminem („nadmiar” ponad stan) ze wspólnej funkcji window.__pgAddonsPozycje (assets/pg-product.js), żeby obie
       drogi miały jedną regułę; bez niej (stary pg-product.js w pamięci przeglądarki) dawna pętla po 1 sztuce */
    if (typeof window.__pgAddonsPozycje === 'function') {
      window.__pgAddonsPozycje().forEach(function (it) {
        if (it && it.id) lista.push(it);
      });
    } else {
      Array.prototype.forEach.call(document.querySelectorAll('[data-direct-accessories] .pg-addons__checkbox:checked'), function (c) {
        var it = { id: parseInt(c.getAttribute('data-variant-id'), 10), quantity: 1 };
        var lead = c.getAttribute('data-lead-time');
        if (lead) it.properties = { '_Termin realizacji': lead };
        if (it.id) lista.push(it);
      });
    }
    lista.push(glowna);
    return lista;
  }

  function korzen() { return (window.routes && window.routes.localeRootUrl) || ''; }

  function doKasy() {
    var f = document.createElement('form');
    f.method = 'post';
    f.action = korzen() + '/cart';
    f.style.display = 'none';
    f.setAttribute('data-pg-kup-teraz-kasa', '');
    var b = document.createElement('button');
    b.type = 'submit';
    b.name = 'checkout';
    b.value = '1';
    f.appendChild(b);
    document.body.appendChild(f);
    b.click();
  }

  function komunikat(btn, tekst) {
    var p = btn.parentNode && btn.parentNode.querySelector('.pg-kup-teraz__blad');
    if (!p) {
      p = document.createElement('p');
      p.className = 'pg-kup-teraz__blad';
      p.setAttribute('role', 'alert');
      btn.insertAdjacentElement('afterend', p);
    }
    p.textContent = tekst;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-pg-kup-teraz]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var form = btn.closest('form');
    if (!form) return;
    var lista = pozycje(form);
    if (!lista.length || !lista[lista.length - 1].id) { komunikat(btn, btn.getAttribute('data-blad') || ''); return; }
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    var stary = btn.parentNode && btn.parentNode.querySelector('.pg-kup-teraz__blad');
    if (stary) stary.textContent = '';
    fetch(korzen() + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: lista })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) throw new Error((j && (j.description || j.message)) || (btn.getAttribute('data-blad') || ''));
          return j;
        });
      })
      .then(function (j) {
        if (typeof window.__pgCartLeadSprawdz !== 'function') return j;
        return window.__pgCartLeadSprawdz().then(function () { return j; });
      })
      .then(czekajNaPM)
      .then(function (stan) {
        btn.setAttribute('data-pg-pm', stan);
        doKasy();
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        komunikat(btn, (err && err.message) || btn.getAttribute('data-blad') || '');
      });
  }, true); /* faza przechwytywania: komponent produktu motywu zatrzymuje bąbelkowanie kliknięć w formularzu (próba w Chrome z oknem 25.10, j0283-0321: brak /cart/add.js) */
})();
